// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QuestionStyles-cls1___b1310030b9cff78db8d{/*!*/}.QuestionStyles-cls2___c8a375bc8928009f277{width:22px;max-height:23px;margin-right:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "QuestionStyles-cls1___b1310030b9cff78db8d",
	"cls2": "QuestionStyles-cls2___c8a375bc8928009f277 QuestionStyles-cls1___b1310030b9cff78db8d"
};
export default ___CSS_LOADER_EXPORT___;
